import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgQuestion(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <circle cx={16} cy={16} r={16} fill="#003099" />
      <path
        fill="white"
        fillRule="evenodd"
        d="M14.5126 15.96L14.5146 15.9476C14.5663 15.6231 14.6609 15.309 14.7975 15.0063L14.8024 14.9954C14.9524 14.6815 15.1482 14.3671 15.3852 14.0519L15.3904 14.045L15.3957 14.0383C15.6504 13.7208 15.9762 13.3781 16.3676 13.0109C16.9648 12.4435 17.4023 11.9474 17.6939 11.5214C17.957 11.137 18.0799 10.7422 18.0799 10.3261C18.0799 9.668 17.8861 9.16856 17.5262 8.78209C17.1826 8.4132 16.6975 8.20427 16.0001 8.20427C15.3027 8.20427 14.8176 8.4132 14.4741 8.78209C14.1141 9.16856 13.9203 9.668 13.9203 10.3261V10.8761H10.8479V10.3261C10.8479 9.60524 10.9591 8.93215 11.1892 8.31285L11.1917 8.30602C11.4356 7.67542 11.7811 7.1253 12.231 6.66348C12.6949 6.1861 13.2482 5.82079 13.884 5.5669C14.5288 5.29312 15.2369 5.16113 16.0001 5.16113C16.7633 5.16113 17.4715 5.29312 18.1162 5.5669C18.7504 5.82014 19.297 6.185 19.7474 6.66341C20.2115 7.12494 20.5581 7.67618 20.7879 8.30928C21.0335 8.92961 21.1523 9.6041 21.1523 10.3261C21.1523 10.8334 21.0786 11.3202 20.9281 11.7833C20.7825 12.2318 20.5807 12.6607 20.3244 13.0696C20.0892 13.4515 19.8165 13.8223 19.5073 14.1822L19.4986 14.1923C19.1972 14.5263 18.8878 14.844 18.5704 15.1455L18.5625 15.153C18.3322 15.3632 18.1515 15.5577 18.0152 15.7363L18.0087 15.7448L18.0018 15.7531C17.8638 15.92 17.7556 16.0808 17.6737 16.235C17.6092 16.3674 17.5602 16.5052 17.5264 16.6494C17.5044 16.7898 17.4925 16.9485 17.4925 17.1271V18.5615H14.4639V16.8842C14.4639 16.5595 14.4793 16.2552 14.5112 15.9724L14.5126 15.96ZM16.0001 21.5586C14.5421 21.5586 13.3601 22.7406 13.3601 24.1986C13.3601 25.6566 14.5421 26.8386 16.0001 26.8386C17.4581 26.8386 18.6401 25.6566 18.6401 24.1986C18.6401 22.7406 17.4581 21.5586 16.0001 21.5586Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgQuestion);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
